import { useEffect, useState } from "react";

/** Returns true when the viewport is at or above the given Tailwind
 *  breakpoint. Tailwind v4 defaults: `lg`=1024px, `xl`=1280px. SSR-safe:
 *  defaults to `true` (desktop) when `window` is unavailable. */
export function useBreakpoint(min: "lg" | "xl"): boolean {
  const px = min === "lg" ? 1024 : 1280;
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === "undefined") return true;
    return window.matchMedia(`(min-width: ${px}px)`).matches;
  });
  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${px}px)`);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [px]);
  return matches;
}
